import entrypoint from './app'

document.body.appendChild(entrypoint)
